import { combineReducers } from 'redux';

import raw from './raw/reducer';
import state from './state/reducer';

export default combineReducers({
  raw,
  state,
});
